import moment from 'moment';

moment.locale('pt-BR');

const dateIsSameOrAfter = expirationData => {
  var currentDate = moment();
  const expirationDataFormatted = moment(expirationData);

  return currentDate.isSameOrAfter(expirationDataFormatted, 'day');
};

const timeFormat = date => moment(date).format('HH:mm');

const dateFormat = date => moment(date).format('DD/MM/YYYY');

const dateFormatWithTime = date => moment(date).format('DD/MM/YYYY HH:mm');

const dateTimeFormat = (date, dateOnly = false) => {
  const isUnix = /^\d+$/.test(date);
  if (!date) {
    return '';
  }
  if (isUnix) {
    const dateMoment = moment.unix(parseInt(date));
    return dateOnly
      ? dateMoment.format('DD/MM/YYYY')
      : dateMoment.format('DD/MM/YYYY - HH:mm:ss');
  } else {
    return dateOnly
      ? moment(date).format('DD/MM/YYYY')
      : moment(date).format('DD/MM/YYYY - HH:mm:ss');
  }
};

const isoDateFormat = (date, dateFormat = null) =>
  date ? moment(date, dateFormat).format('YYYY-MM-DD') : date;

const isoDatetimeFormat = (date, dateFormat = null) =>
  date ? moment(date, dateFormat).format('YYYY-MM-DD - HH:mm:ss') : date;

const clipValueToInewsUnixRange = unixTimestamp => {
  // min/max are based on the approximate signed 32-bit unit epoch range
  const INEWS_TIMESTAMP_MIN = 0;
  const INEWS_TIMESTAMP_MAX = 2 ** 31 - 1;
  return Math.min(
    INEWS_TIMESTAMP_MAX,
    Math.max(INEWS_TIMESTAMP_MIN, unixTimestamp),
  );
};

const dateToUnix = (date, dateFormat = null) => moment(date, dateFormat).unix();

const unixToDuration = duration => {
  const durationNumber = parseInt(duration);
  const hours = Math.floor(durationNumber / 3600).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
  const minutes = Math.floor(
    (durationNumber - hours * 3600) / 60,
  ).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
  const seconds = (
    durationNumber -
    hours * 3600 -
    minutes * 60
  ).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });

  return durationNumber ? `${hours}:${minutes}:${seconds}` : '';
};

const durationToUnix = duration => {
  if (!duration) {
    return '';
  }
  const hours = parseInt(duration.split(':')[0]) * 60 * 60;
  const minutes = parseInt(duration.split(':')[1]) * 60;
  const seconds = parseInt(duration.split(':')[2]);
  return hours + minutes + seconds;
};

const weekdayWithDate = () => moment(new Date()).format('ddd, DD/MM/YYYY');

const weekdayWithSpecificDate = date => moment(date).format('ddd, DD/MM/YYYY');

const toLocalTime = date => {
  if (!date) return date;
  const tempDate = new Date(date.includes('Z') ? date : date + 'Z');
  return tempDate.toISOString();
};

const formatSeconds = (totalSeconds, includeHours = false) => {
  if (!totalSeconds) return '';

  let dateObj = new Date(parseInt(totalSeconds) * 1000);
  let hours = dateObj
    .getUTCHours()
    .toString()
    .padStart(2, '0');
  let minutes = dateObj
    .getUTCMinutes()
    .toString()
    .padStart(2, '0');
  let seconds = dateObj
    .getSeconds()
    .toString()
    .padStart(2, '0');

  return includeHours
    ? `${hours}:${minutes}:${seconds}`
    : `${minutes}:${seconds}`;
};

export {
  weekdayWithDate,
  timeFormat,
  dateFormat,
  dateFormatWithTime,
  dateTimeFormat,
  isoDatetimeFormat,
  isoDateFormat,
  unixToDuration,
  durationToUnix,
  dateToUnix,
  toLocalTime,
  formatSeconds,
  clipValueToInewsUnixRange,
  weekdayWithSpecificDate,
  dateIsSameOrAfter,
};
